import React from "react";
import { Select } from "antd";

const StoreSelector = ({ options, value, onChange, width = "200px" }) => {
  return (
    <div className="mb-2" style={{ marginTop: "10px" }}>
      <Select
        showSearch
        options={options}
        value={value}
        onChange={onChange}
        placeholder="Choose a store..."
        style={{ width: width}}
        className="custom-store-select"
        optionFilterProp="children"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
      <style>{`
        .custom-store-select .ant-select-selector {
          cursor: pointer !important;
        }
      `}</style>
    </div>
  );
};

export default StoreSelector;